import { TableCell } from "@mui/material";
import { StyledFooterCell, StyledTableFooterWrapper } from "./Table.style";

import spliter from "helper/digit-spliter";

export default function EnhancedTableFooterCart(props) {
  const { cartInfo } = props;

  return (
    <StyledTableFooterWrapper>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <TableCell></TableCell>
      <StyledFooterCell>جمع کل :</StyledFooterCell>
      <StyledFooterCell>{spliter(cartInfo.totalPrice)}</StyledFooterCell>
      <TableCell></TableCell>
    </StyledTableFooterWrapper>
  );
};
